import App from './fragments/App';
export default App;
export { mainRoutes, mainLabels, withSubRoute } from './routes';
